import React from 'react';
import ContactListItem from './ContactListItem';

const ContactList = ({ contacts, onSelectContact }) => (
  <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.04)', padding: 0, marginTop: 8 }}>
    {contacts.length === 0 ? (
      <div style={{ padding: 32, color: '#888', textAlign: 'center' }}>No contacts found</div>
    ) : (
      contacts.map((contact, idx) => (
        <ContactListItem key={contact.id} contact={contact} last={idx === contacts.length - 1} onSelectContact={onSelectContact} />
      ))
    )}
  </div>
);

export default ContactList; 